import Swal from "sweetalert2";
import url from '../../../../url.js';
/* global grecaptcha */
export default {
    data() {
        return {
            title: 'Karir',
            dataKarir: [],
            ApiUrl: url.URL,
            siteKey: url.siteKey, // ganti dengan kunci dari Google
            isRecaptchaVisible: false,
            recaptchaVerified: false,
            dataApply: {
                id_career: '',
                positions: '',
                name: '',
                email: '',
                phone: '',
                file: null,
                token: '',
            },
            fileUrl: '',
        }
    },
    mounted() {
        this.fetchData();
        window.onRecaptchaSuccess = this.onRecaptchaSuccess;
    },
    methods: {
        async handleFileChange(event) {
            try{
                const file = event.target.files[0];                
                if (file) {
                    this.fileName = file.name;
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.fileUrl = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
                if (!file) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Silahkan pilih file',
                        timer: 1500
                    })
                    return;
                }
                const allowedTypes = ['application/pdf'];
                if (!allowedTypes.includes(file.type)) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: 'Hanya file PDF yang diperbolehkan',
                        timer: 1500
                    })
                    return;
                }
                const allowedSize = 1 * 1024 * 1024; // 1 MB
                if (file.size > allowedSize) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: `Ukuran file terlalu besar, maksimal ${allowedSize / 1024 / 1024} MB`,
                        timer: 1500
                    })
                    this.resetForm();
                    return;
                }
                this.dataApply.file = file;
            } catch (error) {
                console.error('Error uploading file:', error);
            }
        },
        async fetchData() {
            const response = await fetch(this.ApiUrl + 'career/2');
            const data = await response.json();
            this.dataKarir = data;
        },
        showModal(id) {
            const apply = this.dataKarir.find(item => item.id === id);
            if (apply){
                this.dataApply.id_career = apply.id;
                this.dataApply.positions = apply.positions;
            }
        },
        resetForm() {
            this.fileUrl = '';
            this.dataApply.file = null;
            this.fileName = '';
            this.dataApply.name = '';
            this.dataApply.email = '';
            this.dataApply.phone = '';
            this.dataApply.token = '';
        },
        async addApplicant(){
            try{
                const formData = new FormData();
                const web = 'fwi';
                if (this.dataApply.id_career && this.dataApply.name && this.dataApply.email && this.dataApply.phone && this.dataApply.file && this.dataApply.token) {
                    formData.append('career_id', this.dataApply.id_career);
                    formData.append('name', this.dataApply.name);
                    formData.append('email', this.dataApply.email);
                    formData.append('no_hp', this.dataApply.phone);
                    formData.append('cv', this.dataApply.file);
                    formData.append('id_company', 2);
                    formData.append('token', this.dataApply.token);
                    formData.append('web', JSON.stringify(web));
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Silahkan isi semua data',
                        timer: 1500
                    })
                }

                const response = await fetch(`${this.ApiUrl}upload-data-career`, {
                    method: 'POST',
                    body: formData,
                });
                if (response.ok) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Data uploaded successfully!',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.resetForm();
                }
            } catch (error) {
                console.error('Error uploading file:', error);
            }
        },
        showRecaptcha() {
            this.isRecaptchaVisible = true;

            // Tunggu sampai elemen muncul di DOM baru render ulang
            this.$nextTick(() => {
                if (typeof grecaptcha !== 'undefined') {
                    grecaptcha.render(document.querySelector('.g-recaptcha'), {
                        sitekey: this.siteKey,
                        callback: this.onRecaptchaSuccess
                    });
                }
            });
        },
        onRecaptchaSuccess(token) {
            this.recaptchaVerified = true;
            this.dataApply.token = token; // Simpan token untuk dikirim ke server
            console.log("reCAPTCHA success:", token);
        },
    },
}